import { z } from 'zod';

export const LOCAL_ADMIN_USERNAME = 'CnapseAdmin' as const;

/** SSM SecureString path — one per edge PC serial (isolated per AWS account). */
export function buildLocalAdminPasswordParameterName(serialNumber: string): string {
  const serial = serialNumber.trim();
  if (!serial) {
    throw new Error('serialNumber is required for break-glass parameter path');
  }
  return `/cci/edge/devices/${serial}/local-admin-password`;
}

export const AdminPasswordEscrowedRecordSchema = z.object({
  version: z.literal(1),
  serialNumber: z.string().min(1),
  username: z.literal(LOCAL_ADMIN_USERNAME),
  parameterName: z.string().min(1),
  escrowedAt: z.string().datetime(),
});
export type AdminPasswordEscrowedRecord = z.infer<typeof AdminPasswordEscrowedRecordSchema>;

export const OpsRevealBreakGlassPasswordRequestSchema = z.object({
  reason: z.string().trim().min(3).max(500),
});
export type OpsRevealBreakGlassPasswordRequest = z.infer<
  typeof OpsRevealBreakGlassPasswordRequestSchema
>;

export const OpsRevealBreakGlassPasswordResponseSchema = z.object({
  success: z.literal(true),
  data: z.object({
    serialNumber: z.string(),
    username: z.literal(LOCAL_ADMIN_USERNAME),
    password: z.string().min(1),
    revealedAt: z.string().datetime(),
    parameterName: z.string(),
  }),
});
export type OpsRevealBreakGlassPasswordResponse = z.infer<
  typeof OpsRevealBreakGlassPasswordResponseSchema
>;
